import { PropTypes } from 'prop-types';
import React from 'react';

import { ThreeLineHighlight } from '@components/three-line-highlight';
import NextImage from 'next/legacy/image';
import { ModalFloatingHeader } from '../modal-header';
import { Flex } from '../../../grid';
import backgroundImage from '../../../../../public/static/images/recommendation-engine/new-banner.jpg';
import { P } from '../../../typography/new';

const ModalImageHeader = ({ modalTitle, handleClose, image, description, handleBack }) => {
  return (
    <>
      <ModalFloatingHeader isAbsolute handleClose={handleClose} handleBack={handleBack} px="20px" />
      <Flex justifyContent="center" position="relative" minHeight="393px" width="100%">
        <Flex zIndex={3} top="0" position="absolute" width="100%" height="100%" opacity={0.3} backgroundColor="black" />

        <NextImage
          alt="Fallback background"
          src={image || backgroundImage}
          layout="fill"
          priority
          zIndex={1}
          quality={85}
          objectFit="cover"
          height="100%"
          width="100vw"
          position="absolute"
        />
        <Flex
          position="absolute"
          bottom="0"
          width="100%"
          backgroundColor="warmWhite2"
          borderRadius="32px 32px 0 0"
          height={{ xs: '24px', lg: '32px' }}
          zIndex={4}
        />

        <Flex flexDirection="column" py="40px" alignItems="center" justifyContent="center" zIndex={4}>
          <ThreeLineHighlight heading={modalTitle} my="0" textAlign="center" />
          {description && (
            <P pt="20px" px="40px" color="white" textAlign="center" variant="standard-bold">
              {description}
            </P>
          )}
        </Flex>
      </Flex>
    </>
  );
};

ModalImageHeader.propTypes = {
  handleClose: PropTypes.func.isRequired,
  modalTitle: PropTypes.arrayOf(PropTypes.string).isRequired,
  image: PropTypes.string,
  description: PropTypes.string,
  handleBack: PropTypes.func,
};

ModalImageHeader.defaultProps = {
  image: null,
  description: null,
  handleBack: null,
};

export { ModalImageHeader };
